import InputLabel from '@/components/form/base/InputLabel.tsx';
import { getRangePricesRangeString } from '@/features/shared/pricing/util/PricingFormatter.ts';
import useGetTourPriceRange from '@/features/dashboard/tourConfig/hooks/useGetTourPriceRange.ts';

export const TotalPriceSummary = ({ tourId }: { tourId: string }) => {
  const { data: priceRanges } = useGetTourPriceRange(tourId);

  return (
    <div>
      <InputLabel label="Kwota całkowita" />
      <p className="text-sm font-medium">
        {getRangePricesRangeString(priceRanges)}
      </p>
    </div>
  );
};
